query GetSchedulerStats($input: SchedulerStatsInput!) {
    schedulerStats(input: $input) {
        id
        totalViews
        conversionRate
        totalBookings
        averageTimeUntilBooking {
            formatted
        }
    }
}
